import { render, staticRenderFns } from "./baseUploadImage.vue?vue&type=template&id=85e84cb8&scoped=true"
import script from "./baseUploadImage.vue?vue&type=script&lang=js"
export * from "./baseUploadImage.vue?vue&type=script&lang=js"
import style0 from "./baseUploadImage.vue?vue&type=style&index=0&id=85e84cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e84cb8",
  null
  
)

export default component.exports